// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"40e36828","673":"7833de66"}[chunkId] + ".chunk.js";
};